import { useMemo } from 'react';
import { ColumnsType } from 'antd/lib/table';
import UTCTooltip from 'client/utils/dates';
import { Popover } from 'antd';
import { useGetUserEmailEvents } from '../services/hooks/useGetUserEmailEvents';

type EntryType = {
  timestamp: string;
  subject: string;
  fromEmail: string;
  status: string;
  reason: string;
  opens: number;
  clicks: number;
};

const columns: ColumnsType<EntryType> = [
  {
    title: 'Subject',
    key: 'subject',
    dataIndex: 'subject',
  },
  {
    title: 'From',
    key: 'fromEmail',
    dataIndex: 'fromEmail',
  },
  {
    title: 'Timestamp',
    key: 'timestamp',
    dataIndex: 'timestamp',
    render: (timestamp: string) => {
      return <UTCTooltip date={timestamp} />;
    },
  },
  {
    title: 'Delivery Status',
    key: 'status',
    dataIndex: 'status',
    render: (status, record) => {
      return (
        <div>
          {record.reason ? (
            <Popover title={record.reason}>{status}</Popover>
          ) : (
            status
          )}
        </div>
      );
    },
  },
  {
    title: 'Click Count',
    key: 'clicks',
    dataIndex: 'clicks',
  },
  {
    title: 'Open Count',
    key: 'opens',
    dataIndex: 'opens',
  },
];

const useUserKeyEventsTable = (idUser: number, enabled: boolean) => {
  const { data, isLoading } = useGetUserEmailEvents({
    enabled,
    params: { idUser },
  });

  const dataSource: Array<EntryType> = useMemo(() => {
    if (!data) {
      return [];
    }

    return data.userEmailEvents.map((event) => ({
      timestamp: event.timestamp,
      subject: event.subject,
      fromEmail: event.fromEmail,
      status: event.status,
      reason: event.reason,
      clicks: event.clicks,
      opens: event.opens,
    }));
  }, [data]);

  return {
    columns,
    dataSource,
    isLoading,
  };
};

export default useUserKeyEventsTable;
